module.exports = __webpack_public_path__ + "toggleOff.0f695b55.png";